import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'
import BaseIcon from '../IconV1'

export const Icon = styled(BaseIcon)`
  font-size: 24px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  //right: 15px;
  text-align: center;
  height: 100%;
  color: ${p => p.theme.iconColor};

  ${p =>
    p.before
      ? `
    left: 15px;
  `
      : `
    right: 15px;
  `};
`

export const StyledInputLabel = styled.span`
  transition: all 0.2s;
  position: absolute;
  top: 2px;
  left: 2px;
  height: 56px;
  line-height: 56px;
  font-size: 22px;
  ${p => p.normalFont && 'font-size: 1.125rem;'}
  color: #64c5af;
  background-color: white;
  //margin-left: 15px;
  left: 15px;
  padding: 0 5px;

  &:focus {
    padding-left: 19px;
    border: 2px solid ${p => p.theme.focusBorderColor};
  }

  &.visited {
    top: -11px;
    height: 22px;
    line-height: 22px;
    left: 10px;
    padding: 0 5px;
    font-size: 16px;
    z-index: 3;
    color: ${p => p.theme.labelColor};
  }
`

export const StyledInputWrapper = styled.div`
  position: relative;
`

export const StyledInput = styled.textarea`
  height: 180px;
  line-height: 30px;
  font-size: 1.125rem;
  color: ${color.MORTAR};
  background-color: transparent;
  width: 100%;
  padding-left: 20px;
  border: 1px solid ${p => p.theme.borderColor};
  transition: border-color 0.2s;
  position: relative;
  z-index: 2;
  padding-top: 20px;
  font-family: 'sidecarta-sans', sans-serif;

  ${Icon} ~ & {
    padding-left: 50px;
  }

  &::placeholder {
    color: transparent;
    transition: color 0.2s;
    transition-delay: 0.2s;
  }

  &.visited {
    &::placeholder {
      color: #aaa;
    }
  }

  &:focus {
    padding-left: 19px;
    border: 2px solid ${p => p.theme.focusBorderColor};
  }

  ${Icon} ~ &:focus {
    padding-left: 49px;
  }
`
